export default Object.freeze( {
	RECENT: "RECENT",
	UPCOMING: "UPCOMING",
} );



// WEBPACK FOOTER //
// ./src/constants/TeamOverviewMeetingFilter.js